var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 8.33333C1.66669 7.8731 2.03978 7.5 2.50002 7.5H17.5C17.9603 7.5 18.3334 7.8731 18.3334 8.33333C18.3334 8.79357 17.9603 9.16667 17.5 9.16667H2.50002C2.03978 9.16667 1.66669 8.79357 1.66669 8.33333Z",
    fill: "#4F5E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50002 2.5C7.96026 2.5 8.33335 2.8731 8.33335 3.33333V16.6667C8.33335 17.1269 7.96026 17.5 7.50002 17.5C7.03978 17.5 6.66669 17.1269 6.66669 16.6667V3.33333C6.66669 2.8731 7.03978 2.5 7.50002 2.5Z",
    fill: "#4F5E71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66669 4.16667C1.66669 3.24619 2.41288 2.5 3.33335 2.5H16.6667C17.5872 2.5 18.3334 3.24619 18.3334 4.16667V15.8333C18.3334 16.7538 17.5872 17.5 16.6667 17.5H3.33335C2.41288 17.5 1.66669 16.7538 1.66669 15.8333V4.16667ZM16.6667 4.16667H3.33335V15.8333H16.6667V4.16667Z",
    fill: "#4F5E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateList);
export default __webpack_public_path__ + "static/media/rate-list.f4e6523d5cac44c9ca7f3a604d7a8dfa.svg";
export { ForwardRef as ReactComponent };